import { motion } from 'framer-motion';
import { PageTransition, StaggerContainer, StaggerItem } from '../components/PageTransition';
import { BackButton } from '../components/BackButton';
import { BorderCard } from '../components/BorderCard';
import { ExternalLink } from 'lucide-react';

const footwear = [
  { 
    id: 'sneakers', 
    title: 'Sneakers', 
    description: 'Casual footwear designed for comfort, versatility, and everyday wear.',
    link: 'https://www.canva.com/design/DAHDiz42ZyU/tcWkOcoSEbBf1VP_hZgbJw/view?utm_content=DAHDiz42ZyU&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h7275809298'
  },
  { 
    id: 'loafers', 
    title: 'Loafers', 
    description: 'Smart casual slip-on footwear offering effortless style and comfort.',
    link: 'https://www.canva.com/design/DAHDb3p2d6g/qCg11Akvj9PDidB3PcLzwA/view?utm_content=DAHDb3p2d6g&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h713da800cf'
  },
  { 
    id: 'sandals', 
    title: 'Sandals', 
    description: 'Open footwear designed for breathable comfort and relaxed casual use.',
    link: 'https://www.canva.com/design/DAHDb176JQc/wGQs3wdQiahBB1O_T2jgPw/view?utm_content=DAHDb176JQc&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h90ec2d6911'
  },
];

const FootwearCard = ({ item }) => {
  return (
    <a 
      href={item.link}
      target="_blank"
      rel="noopener noreferrer"
      className="block"
      data-testid={`footwear-${item.id}`}
    >
      <BorderCard className="p-10 text-center group h-full">
        <div className="w-20 h-20 mx-auto mb-6 border border-[rgba(26,26,26,0.1)] flex items-center justify-center group-hover:border-[#D32F2F] transition-colors duration-500 rounded-full">
          <span className="text-2xl font-light text-[#1A1A1A]">
            {item.title.charAt(0)}
          </span>
        </div>
        <h3 className="text-sm uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-3">
          {item.title}
        </h3>
        <p className="text-xs text-[#1A1A1A]/60 leading-relaxed mb-6">
          {item.description}
        </p>
        <div className="flex items-center justify-center gap-2 text-[#D32F2F]">
          <span className="text-[10px] uppercase tracking-wider font-medium group-hover:underline">
            View Training Guide
          </span>
          <ExternalLink size={12} />
        </div>
      </BorderCard>
    </a>
  );
};

const FootwearPage = () => {
  return (
    <PageTransition className="min-h-screen bg-[#F8F6F2] py-24 px-6">
      <div className="grain-overlay" />
      <BackButton to="/what/product" label="Back" />

      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#1A1A1A]/60 mb-4">
            Product Training
          </h2>
          <h1 className="text-4xl md:text-5xl font-light tracking-tight text-[#1A1A1A]">
            Footwear
          </h1>
        </motion.div>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {footwear.map((item) => (
            <StaggerItem key={item.id}>
              <FootwearCard item={item} />
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </PageTransition>
  );
};

export default FootwearPage;
